<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto d-flex gap-3 align-items-center">
          <h2 class="mb-0">
            {{ orderType === "inventory-sales" ? "Inventory Sales" : "Orders" }}
          </h2>
          <span class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
            <jni-spinner></jni-spinner>
          </span>

          <label
            for="Canceled"
            class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radioButton
              inputId="Canceled"
              name="orderStatus"
              class="me-2"
              [(ngModel)]="selectedRadioButton"
              value="Canceled"
              (onClick)="getOrderOnChange('Canceled')" />
            <span class="link">Canceled</span>
          </label>

          <label
            for="Delivered"
            class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radioButton
              inputId="Delivered"
              name="orderStatus"
              class="me-2"
              [(ngModel)]="selectedRadioButton"
              value="Delivered"
              (onClick)="getOrderOnChange('Delivered')" />
            <span class="link">Delivered</span>
          </label>

          <label
            for="Invoiced"
            class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radioButton
              inputId="Invoiced"
              name="orderStatus"
              class="me-2"
              [(ngModel)]="selectedRadioButton"
              value="Invoiced"
              (onClick)="getOrderOnChange('Invoiced')" />
            <span class="link">Invoiced</span>
          </label>

          <label
            for="Openorder"
            class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radioButton
              inputId="Openorder"
              name="orderStatus"
              class="me-2"
              [(ngModel)]="selectedRadioButton"
              value="Openorder"
              (onClick)="getOrderOnChange('Open order')" />
            <span class="link">Open order</span>
          </label>

          <label for="All" class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radioButton
              inputId="All"
              name="orderStatus"
              class="me-2"
              [(ngModel)]="selectedRadioButton"
              value="All"
              (onClick)="getOrderOnChange('All')" />
            <span class="link">All</span>
          </label>
        </span>
        <span class="d-flex gap-3 customizefilter-btn align-items-center">
          <div
            class="prospects-panel d-flex justify-content-between gap-3 align-items-center"
            *ngIf="!isAdditionalFilters">
            <button
              *ngIf="
                _sharedService.getOrderSearchValue() &&
                _sharedService.getOrderSearchValue()?.length
              "
              class="btn btn-warning w-30 ms-4"
              type="submit"
              (click)="onClear()">
              Clear
            </button>
            <div *ngIf="searchPlaceholder !== 'Search'" class="ms-2">
              <span class="text-primary font-weight-bold">{{
                totalRecords
              }}</span>
              <span> Results for </span>
              <span class="text-primary">
                <!-- <span>"</span> -->
                <span>{{ _sharedService.getOrderSearchValue() }}</span>
                <!-- <span>"</span> -->
              </span>
            </div>
          </div>

          <p-button
            label="Export excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            class="link"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />

          <p-button
            label="Add New Order"
            icon="pi pi-plus"
            (click)="onOrdersRedirection()"
            class="fullwdth secondary-btn" />

          <span
            class="cross-border"
            *ngIf="isFromSupportAllocation"
            (click)="closeModal()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="col-lg-12">
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [rows]="50"
          [value]="filterSaleordersListing"
          [(selection)]="selectedorderListing"
          styleClass="p-datatable-customers ordersListing search-more"
          [showCurrentPageReport]="true"
          scrollDirection="both"
          [scrollable]="true"
          scrollHeight="calc(100vh - 261px)"
          [size]="'small'"
          [resizableColumns]="true"
          [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          [filterDelay]="0"
          (onFilter)="onFilter($event, dt)"
          (onPage)="setMyPagination(dt)"
          selectionMode="multiple"
          sortMode="multiple"
          [lazy]="true"
          (onLazyLoad)="getAllSaleOrder($event)"
          [totalRecords]="totalRecords"
          styleClass="table-listing"
          [tableStyle]="{ 'min-width': '2000px' }"
          [globalFilterFields]="[
            'salesOrderIdD365',
            'salesOrderStatusD365',
            'organizationNameD365',
          ]">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th class="max-width-2" pSortableColumn="salesOrderIdD365">
                Order # <p-sortIcon field="salesOrderIdD365"></p-sortIcon>
              </th>
              <th
                class="max-width-3"
                pSortableColumn="orderPercentCompleteD365">
                PCT
                <p-sortIcon field="orderPercentCompleteD365"></p-sortIcon>
              </th>
              <th class="max-width-4" pSortableColumn="salesOrderStatusD365">
                Status
                <p-sortIcon field="salesOrderStatusD365"></p-sortIcon>
              </th>
              <th class="max-width-5" pSortableColumn="organizationNameD365">
                Client Name
                <p-sortIcon field="organizationNameD365"></p-sortIcon>
              </th>
              <th
                *ngIf="userRole === enumUserRole.Admin"
                pSortableColumn="jniSalesInventoryD365">
                Inventory Sales
              </th>
              <th
                class="max-width-4"
                pSortableColumn="jobNameD365"
                [ngClass]="{ trimmedby30char: descriptionCharacterCond }">
                Job Name
                <p-sortIcon field="jobNameD365"></p-sortIcon>
              </th>
              <th class="max-width-4" pSortableColumn="buyerD365">
                Buyer
                <p-sortIcon field="buyerD365"></p-sortIcon>
              </th>
              <th class="max-width-4" pSortableColumn="inHandsDateD365">
                In Hands
                <p-sortIcon field="inHandsDateD365"></p-sortIcon>
              </th>
              <th class="max-width-4" pSortableColumn="createdDate">
                Created
                <p-sortIcon field="createdDate"></p-sortIcon>
              </th>
              <th class="max-width-4" pSortableColumn="orderSubTotal">
                Subtotal
                <p-sortIcon field="orderSubTotal"></p-sortIcon>
              </th>
              <th class="max-width-7">PrePay</th>
              <th class="max-width-7">Comm</th>
              <th class="max-width-7">GP $</th>
              <th class="max-width-7">Gp%</th>
              <th class="max-width-4">Curr</th>

              <th
                class="max-width-4"
                pSortableColumn="customerPONumberD365"
                [ngClass]="{ trimmedby15char: custPoCharacterCount }">
                Cust PO #
                <p-sortIcon field="customerPONumberD365"></p-sortIcon>
              </th>
              <th class="max-width-4">BC</th>
              <th class="max-width-4">Prime Support</th>
              <th>Paid Status</th>
            </tr>
            <tr>
              <th></th>
              <th class="max-width-2">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="salesOrderIdD365"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-3"></th>
              <th class="max-width-4">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="salesOrderStatusD365"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-5">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="organizationNameD365"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-4" *ngIf="userRole === enumUserRole.Admin">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="jniSalesInventoryD365"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-4">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="jobNameD365"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-4">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="buyerD365"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-4">
                <div class="d-flex justify-content-center">
                  <jni-date-filter
                    [dataList]="saleordersListing"
                    [filterMode]="filterMode"
                    [columnName]="inHandFieldName"
                    (emitCancelFilter)="onFilterInput($event, 'clear')"
                    (emitApplyFilter)="onFilterInput($event)">
                  </jni-date-filter>
                </div>
              </th>
              <th class="max-width-4">
                <div class="d-flex justify-content-center">
                  <p-columnFilter
                    field="createdDate"
                    [showButtons]="false"
                    [showMenu]="false">
                    <ng-template
                      class="prospects-panel d-flex justify-content-between ms-2 me-auto"
                      pTemplate="filter"
                      let-value
                      let-filter="filterCallback">
                      <div class="p-d-flex p-flex-column p-ai-center">
                        <div
                          class="filter-toggle text-center"
                          (click)="showFilterDialog = !showFilterDialog">
                          <i class="pi pi-filter"></i>
                        </div>
                        <p-dialog
                          header="Select Filter Criteria"
                          [position]="'center'"
                          [resizable]="false"
                          [draggable]="false"
                          [(visible)]="showFilterDialog"
                          [style]="{
                            width: '270px',
                            height: '335px',
                            'border-radius': '10px',
                            overflow: 'visible',
                          }">
                          <div class="p-fluid p-dir-col p-3">
                            <div class="d-flex flex-column mb-1">
                              <label>Match Mode</label>
                              <p-select
                                [options]="matchModeOptions"
                                [(ngModel)]="selectedMatchMode"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Select Match Mode"
                                required="true"></p-select>
                            </div>
                            <div class="d-flex flex-column mb-1">
                              <label for="startDate"
                                >{{
                                  selectedMatchMode !== "between"
                                    ? "Date"
                                    : "Start Date"
                                }}
                              </label>
                              <p-datepicker
                                [(ngModel)]="startDate"
                                [showButtonBar]="true"
                                [appendTo]="'body'"
                                dateFormat="mm-dd-yy"></p-datepicker>
                            </div>
                            <div
                              class="d-flex flex-column mb-1"
                              *ngIf="selectedMatchMode === 'between'">
                              <label>End Date</label>
                              <p-datepicker
                                [(ngModel)]="endDate"
                                class="w-100"
                                [showButtonBar]="true"
                                [appendTo]="'body'"
                                dateFormat="mm-dd-yy"></p-datepicker>
                            </div>

                            <div
                              class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center gap-2">
                              <p-button
                                label="Clear"
                                (click)="onFilterInput($event, 'clear')"
                                variant="outlined"
                                severity="secondary" />

                              <p-button
                                label="Apply"
                                [disabled]="startDate === ''"
                                type="submit"
                                (click)="onFilterInput($event)" />

                              <!-- <button
                                class="btn btn-secondary me-3"
                                type="button"
                                (click)="onFilterInput($event, 'clear')">
                                Clear
                              </button>
                              <button
                                class="btn btn-primary"
                                [disabled]="startDate === ''"
                                type="submit"
                                (click)="onFilterInput($event)">
                                Apply
                              </button> -->
                            </div>
                          </div>
                        </p-dialog>
                      </div>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </th>

              <th class="max-width-4">
                <!-- Subtotal -->
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="orderSubTotal"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-4"></th>
              <th class="max-width-4"></th>

              <th class="max-width-4"></th>
              <th class="max-width-4"></th>
              <th class="max-width-7">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="foreignCurrencyD365"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-4">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="customerPONumberD365"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-4">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="brandingConsultant"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-4">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="accountsCoordinator"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showButtons]="false"
                    [showClearButton]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-4"></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-saleordersListing
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="saleordersListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  class=""
                  [value]="saleordersListing"
                  [pSelectableRow]="saleordersListing"></p-tableCheckbox>
              </td>
              <td class="number">
                <a
                  class="link"
                  (click)="
                    redirectToSummary(saleordersListing.salesOrderIdD365)
                  ">
                  {{ saleordersListing.salesOrderIdD365 }}</a
                >
              </td>
              <td class="number text-center">
                <a
                  *ngIf="
                    saleordersListing?.invoiceProposalExists !== '' &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() ===
                      'yes'
                  "
                  class="link"
                  (click)="
                    getProjectInvoiceProposalsBySalesOrderId(
                      saleordersListing.salesOrderIdD365
                    )
                  ">
                  {{
                    saleordersListing.orderPercentCompleteD365 | number: "1.2-2"
                  }}</a
                >

                <a
                  *ngIf="
                    saleordersListing?.orderPercentCompleteD365 > 0 &&
                    saleordersListing?.orderPercentCompleteD365 < 93.99 &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() !==
                      'yes'
                  "
                  class="link"
                  (click)="
                    redirectToIRSummary(
                      saleordersListing?.salesOrderIdD365,
                      saleordersListing?.projIdD365
                    )
                  ">
                  {{
                    saleordersListing.orderPercentCompleteD365 | number: "1.2-2"
                  }}</a
                >

                <a
                  *ngIf="
                    saleordersListing?.orderPercentCompleteD365 >= 94 &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() !==
                      'yes'
                  "
                  class="link"
                  (click)="
                    redirectToIRSummary(
                      saleordersListing?.salesOrderIdD365,
                      saleordersListing?.projIdD365
                    )
                  ">
                  {{
                    saleordersListing.orderPercentCompleteD365 | number: "1.2-2"
                  }}</a
                >
              </td>
              <td class="status">
                <a
                  class="link"
                  (click)="onStatusClick(saleordersListing.salesOrderIdD365)"
                  *ngIf="
                    saleordersListing?.salesOrderStatusD365?.toLowerCase() ===
                      'invoiced' &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() !==
                      'yes'
                  ">
                  {{ saleordersListing.salesOrderStatusD365 }}
                </a>
                <span
                  *ngIf="
                    !(
                      saleordersListing?.salesOrderStatusD365?.toLowerCase() ===
                      'invoiced'
                    ) &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() !==
                      'yes'
                  "
                  >{{ saleordersListing.salesOrderStatusD365 }}</span
                >
                <span
                  class="i-perview-color"
                  *ngIf="
                    saleordersListing?.invoiceProposalExists !== '' &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() ===
                      'yes'
                  ">
                  I-Preview
                </span>
              </td>

              <td class="name">
                <a
                  class="link"
                  (click)="
                    redirectToClientSummary(
                      saleordersListing.customerAccountNumber
                    )
                  ">
                  {{ saleordersListing.organizationNameD365 }}</a
                >
              </td>
              <td *ngIf="userRole === enumUserRole.Admin" class="name">
                {{
                  saleordersListing.jniSalesInventoryD365 | jniBooleanToString
                }}
              </td>
              <td
                class="jname"
                [ngClass]="{
                  'trimmeddescription trimmedby30char':
                    descriptionCharacterCond,
                }">
                {{ descriptionCharacterCount(saleordersListing.jobNameD365) }}
                {{ saleordersListing.jobNameD365 }}
              </td>
              <td class="buyer">{{ saleordersListing.buyerD365 }}</td>
              <td class="inhandate">
                {{ saleordersListing.inHandsDateD365 | date: "MM-dd-yyyy" }}
              </td>
              <td class="date-time">
                <span *ngIf="saleordersListing?.createdDate | hidedynamicsdate">
                  {{ saleordersListing.createdDate | date: "MM-dd-yyyy" }}
                </span>
              </td>
              <td class="subtotal">
                {{
                  saleordersListing.orderSubTotal
                    | currency
                      : saleordersListing.foreignCurrencyD365
                      : "symbol"
                      : "0.2-2"
                }}
              </td>

              <td class="prepay">
                {{
                  saleordersListing.clientDepositD365
                    | currency
                      : saleordersListing.foreignCurrencyD365
                      : "symbol"
                      : "0.2-2"
                }}
              </td>
              <td class="commission">
                {{ saleordersListing.commissionD365 | currency }}
              </td>
              <td class="gp">
                {{ saleordersListing.grossProfitD365 | currency }}
              </td>
              <td class="gp">
                <span
                  *ngIf="
                    saleordersListing.grossProfitPercentageD365 !== 'NaN' &&
                    getInfinity(saleordersListing.grossProfitPercentageD365)
                  ">
                  {{
                    saleordersListing.grossProfitPercentageD365
                      | number: "1.2-2"
                  }}
                </span>
                <span
                  *ngIf="
                    saleordersListing.grossProfitPercentageD365 === 'NaN' &&
                    !getInfinity(saleordersListing.grossProfitPercentageD365)
                  ">
                  {{ 0 | number: "1.2-2" }}
                </span>
              </td>
              <td class="currency">
                {{ saleordersListing.foreignCurrencyD365 }}
              </td>
              <td
                class="cust-po"
                [ngClass]="{
                  'trimmeddescription trimmedby15char': custPoCharacterCount,
                }">
                {{
                  custPoCharacterCountMethod(
                    saleordersListing.customerPONumberD365
                  )
                }}
                {{ saleordersListing.customerPONumberD365 }}
              </td>
              <td class="bconsultant">
                {{ saleordersListing.brandingConsultant }}
              </td>
              <td class="bconsultant">
                {{ saleordersListing.accountsCoordinatorNameD365 }}
              </td>
              <td class="name">
                <span
                  *ngIf="
                    saleordersListing?.prepayD365 === 'Paid' ||
                    saleordersListing?.prepayD365 === 'Unpaid'
                  ">
                  {{ saleordersListing.prepayD365 }}
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No sale orders found.</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer" *ngIf="false">
            <tr
              *ngIf="
                listAfterGridFilter.length > currentPagination && lastPageStatus
              ">
              <td colspan="20">More records exist</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [orderType]="orderType"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>
<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeClientModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [isModal]="true"
      [clientIdFromModal]="customerId"
      (closeEvent)="closeClientModal()">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<jni-invoice-pdf-dialogue
  [displayModal]="invoicePdfDialogue"
  *ngIf="invoiceList?.length"
  (closeDialogEvent)="closeUrlDialog()"
  [invoiceList]="invoiceList"></jni-invoice-pdf-dialogue>

<jni-invoice-preview-list-dailog
  [displayModal]="displayProjectInvoiceProposal"
  [projectInvoicesProposalList]="projectInvoicesProposalList"
  (closeDialogEvent)="closeProjectInvoiceProposalEvent()"
  [showSmallLoader]="popupSmallLoader">
</jni-invoice-preview-list-dailog>
